import cryptojs from 'crypto-js';
const secret_key = process.env.REACT_APP_SECRET_KEY;

export const encrypt = (text, custom_secret_key) => {
  const key = custom_secret_key || secret_key;
  return cryptojs.AES.encrypt(text, key).toString()
};

export const decrypt = (encrypted, custom_secret_key) => {
  const key = custom_secret_key || secret_key;
  return cryptojs.AES.decrypt(encrypted, key).toString(cryptojs.enc.Utf8);
}